import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@heroui/react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import SplitText from '../../ui/SplitText.jsx';
import Magnet from '../../ui/Magnet.jsx';
import { cn } from '../../../utils/cn.js';

const SidebarHeader = ({ collapsed, toggleSidebar }) => {
    return (
        <div className={cn(
            "relative z-20 flex items-center justify-between px-4 py-6 transition-all duration-300",
            collapsed ? "justify-center px-2 flex-col gap-4" : ""
        )}>
            {/* Logo & Brand */}
            <Link to="/dashboard" className={cn(
                "flex items-center gap-3 overflow-hidden group",
                collapsed ? "justify-center w-full" : ""
            )}>
                <div className="relative flex-shrink-0 w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl flex items-center justify-center shadow-lg shadow-blue-500/20 group-hover:shadow-blue-500/40 transition-shadow duration-300">
                    <img src="/logo/dragon_2534463.png" alt="Dragon" className="w-8 h-8 object-contain" />
                </div>

                {/* Brand Text (Only visible when expanded) */}
                <AnimatePresence mode='wait'>
                    {!collapsed && (
                        <motion.div
                            initial={{ opacity: 0, width: 0 }}
                            animate={{
                                opacity: 1,
                                width: 'auto',
                                transition: {
                                    opacity: { delay: 0.1, duration: 0.2 },
                                    width: { type: "spring", stiffness: 260, damping: 26 }
                                }
                            }}
                            exit={{
                                opacity: 0,
                                width: 0,
                                transition: {
                                    opacity: { duration: 0.15 },
                                    width: { type: "spring", stiffness: 300, damping: 30 }
                                }
                            }}
                            className="flex flex-col ml-1 whitespace-nowrap overflow-hidden"
                        >
                            <h1 className="text-xl font-bold tracking-tight text-slate-900 dark:text-white leading-none">
                                <SplitText
                                    text="Dragon 云加速"
                                    className="inline-block"
                                    delay={30}
                                    from={{ opacity: 0, transform: 'translate3d(0,50%,0)' }}
                                    to={{ opacity: 1, transform: 'translate3d(0,0,0)' }}
                                    threshold={0.2}
                                    rootMargin="-50px"
                                />
                            </h1>
                            <span className="text-[10px] font-semibold text-slate-500 uppercase tracking-widest mt-0.5">
                                Cloud Acceleration
                            </span>
                        </motion.div>
                    )}
                </AnimatePresence>
            </Link>

            {/* Toggle Button — Sidebar 仅桌面端渲染，所以始终显示 */}
            <div className={cn(collapsed ? "mt-2" : "")}>
                <Magnet padding={15} disabled={false} magnetStrength={3}>
                    <Button
                        isIconOnly
                        size="sm"
                        variant="ghost"
                        onClick={toggleSidebar}
                        className="min-w-8 w-8 h-8 rounded-full text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800"
                    >
                        {collapsed ? <ChevronRight className="w-5 h-5" /> : <ChevronLeft className="w-5 h-5" />}
                    </Button>
                </Magnet>
            </div>
        </div>
    );
};

export default SidebarHeader;
